var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { transient, autoinject } from 'aurelia-dependency-injection';
import { PLATFORM } from 'aurelia-pal';
import { Router } from 'aurelia-router';
import { I18N } from 'aurelia-i18n';
import { TokenClient } from '../../../../services/authentication/token-client.service';
import { ClientLotteryClientService } from '../../../../services/modules/client/client-lottery-client-service';
import { DialogClientService } from '../../../../services/basics/dialog-client.service';
import { ConfigClientService } from '../../../../services/modules/client-config.service';
import { BaseBundles } from '../../templates/base-bundles';
var RenderBundlesSectioned = /** @class */ (function (_super) {
    __extends(RenderBundlesSectioned, _super);
    function RenderBundlesSectioned(lotteryClientService, router, tokenClient, i18n, dialogClient, configClientService) {
        var _this = _super.call(this, lotteryClientService, router, tokenClient, i18n, dialogClient, configClientService) || this;
        _this.sections = [];
        return _this;
    }
    RenderBundlesSectioned_1 = RenderBundlesSectioned;
    RenderBundlesSectioned.prototype.activate = function (params) {
        this.loadSections();
        return _super.prototype.activate.call(this, params);
    };
    RenderBundlesSectioned.prototype.loadSections = function () {
        var _this = this;
        try {
            var server = window.server;
            var layout = server && server.renderLayout ? server.renderLayout : null;
            var bundles = layout && layout.bundles ? layout.bundles : null;
            if (bundles && bundles.length) {
                this.sections = bundles
                    .filter(function (s) { return s.visible !== false; })
                    .map(function (s) { return _this.prepareRow(s); })
                    .filter(function (s) { return _this.isRow(s) ? s.children.length > 0 : !!_this.blockModule(s); })
                    .sort(function (a, b) { return (a.order || 0) - (b.order || 0); });
            }
        }
        catch (_a) {
            this.sections = [];
        }
    };
    RenderBundlesSectioned.prototype.isRow = function (section) {
        return !!section && section.type === 'Row';
    };
    /** For a Row, keep only visible children that resolve to a block; leaf sections pass through. */
    RenderBundlesSectioned.prototype.prepareRow = function (section) {
        var _this = this;
        if (this.isRow(section)) {
            section.children = (section.children || []).filter(function (c) { return c.visible !== false && !!_this.blockModule(c); });
        }
        return section;
    };
    Object.defineProperty(RenderBundlesSectioned.prototype, "shell", {
        /** The shell itself - bound as each block's `host` (resolves at the root scope, even inside a Row repeat). */
        get: function () {
            return this;
        },
        enumerable: false,
        configurable: true
    });
    /** Resolves the block module for a section: explicit variant else the type's default. Null skips it. */
    RenderBundlesSectioned.prototype.blockModule = function (section) {
        if (!section) {
            return null;
        }
        var variant = section.variant || RenderBundlesSectioned_1.defaultVariantForType[section.type];
        return variant ? RenderBundlesSectioned_1.variantModules[variant] : null;
    };
    var RenderBundlesSectioned_1;
    RenderBundlesSectioned.variantModules = {
        'bundles-list-t7': PLATFORM.moduleName('app/styles/client/render-engine/blocks/bundles-list/bundles-list'),
        'advert-t7': PLATFORM.moduleName('app/styles/client/render-engine/blocks/advert/advert'),
        'banners-custom': PLATFORM.moduleName('app/styles/client/render-engine/blocks/banners-custom/banners-custom'),
    };
    /** Default variant per section type - used when a section has no explicit variant (old docs). */
    RenderBundlesSectioned.defaultVariantForType = {
        BundlesList: 'bundles-list-t7',
        Advert: 'advert-t7',
    };
    RenderBundlesSectioned = RenderBundlesSectioned_1 = __decorate([
        autoinject,
        transient(),
        __metadata("design:paramtypes", [ClientLotteryClientService, Router, TokenClient,
            I18N, DialogClientService, ConfigClientService])
    ], RenderBundlesSectioned);
    return RenderBundlesSectioned;
}(BaseBundles));
export { RenderBundlesSectioned };
